import axios from 'axios';

const baseUrl = "https://fyp-api.avinna.com.np/api/";


export default axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    }
});

export const axiosPrivate = axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    }
});